module.exports = __webpack_public_path__ + "static/media/12-4649_CCA.8bf85329.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/12-4649_CCA.jpg
// module id = 147
// module chunks = 0